"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var SentryLog = /** @class */ (function () {
    function SentryLog(props) {
        var _this = this;
        this.Sentry = null;
        this.dsn = "";
        this.getSentry = function () { return __awaiter(_this, void 0, void 0, function () {
            var Sentry;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.Sentry) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require("@sentry/nextjs")); })];
                    case 1:
                        Sentry = _a.sent();
                        this.Sentry = Sentry;
                        this.Sentry.init({
                            dsn: this.dsn,
                        });
                        return [2 /*return*/, this.Sentry];
                    case 2: return [2 /*return*/, this.Sentry];
                }
            });
        }); };
        this.isNetworkError = function (err) {
            return err instanceof TypeError &&
                /The internet connection appears to be offline|Failed to fetch|Load failed|Network request failed|NetworkError when attempting to fetch resource|The network connection was lost/i.test(err.message);
        };
        this.isAbortError = function (err) {
            return err instanceof Error && err.name == "AbortError";
        };
        this.logError = function (error) { return __awaiter(_this, void 0, void 0, function () {
            var Sentry, isInfoMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSentry()];
                    case 1:
                        Sentry = _a.sent();
                        if (!!Sentry) {
                            isInfoMessage = typeof error === "string" && error.length > 0;
                            if (isInfoMessage ||
                                this.isNetworkError(error) ||
                                this.isAbortError(error) ||
                                !(error instanceof Error)) {
                                return [2 /*return*/];
                            }
                            Sentry === null || Sentry === void 0 ? void 0 : Sentry.captureException(error);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        this.withScopeAdded = function (error, errorInfo) { return __awaiter(_this, void 0, void 0, function () {
            var Sentry;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSentry()];
                    case 1:
                        Sentry = _a.sent();
                        Sentry.withScope(function (scope) {
                            Object.entries(errorInfo).map(function (_a) {
                                var key = _a[0], value = _a[1];
                                scope.setExtra(key, value);
                            });
                            _this.logError(error);
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        this.dsn = props.dsn;
    }
    return SentryLog;
}());
exports.default = SentryLog;
